"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactivity = exports.from = exports.fromEvent = void 0;
const core_1 = require("../core");
const routing_1 = require("../routing");
const observable_1 = require("./observable");
const fromEvent = (element, eventName) => {
    const observable$ = new observable_1.Observable();
    const onEvent = (event) => {
        observable$.emit(event);
    };
    element.addEventListener(eventName, onEvent);
    return observable$;
};
exports.fromEvent = fromEvent;
const from = (initialValue) => {
    const observable$ = new observable_1.Observable();
    observable$.emit(initialValue);
    return observable$;
};
exports.from = from;
const reactivity = (fn) => {
    let observable$ = null;
    if (!fn) {
        return null;
    }
    const stateManager = (0, core_1.state)((newValue) => {
        if (observable$) {
            observable$.emit(fn({
                state: () => stateManager(newValue),
                params: routing_1.params,
                provide: core_1.provide,
            }));
        }
    });
    const element = fn({ state: stateManager, params: routing_1.params, provide: core_1.provide });
    observable$ = (0, exports.from)(element);
    return observable$;
};
exports.reactivity = reactivity;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVhY3Rpdml0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYWNrYWdlcy9yZWFjdGl2aXR5L3JlYWN0aXZpdHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0Esa0NBQXlDO0FBQ3pDLHdDQUFvQztBQUNwQyw2Q0FBMEM7QUFFbkMsTUFBTSxTQUFTLEdBQUcsQ0FDdkIsT0FBVSxFQUNWLFNBQW9DLEVBQ3BDLEVBQUU7SUFDRixNQUFNLFdBQVcsR0FBRyxJQUFJLHVCQUFVLEVBQVMsQ0FBQztJQUU1QyxNQUFNLE9BQU8sR0FBRyxDQUFDLEtBQVksRUFBRSxFQUFFO1FBQy9CLFdBQVcsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDMUIsQ0FBQyxDQUFDO0lBRUYsT0FBTyxDQUFDLGdCQUFnQixDQUFDLFNBQVMsRUFBRSxPQUFPLENBQUMsQ0FBQztJQUU3QyxPQUFPLFdBQVcsQ0FBQztBQUNyQixDQUFDLENBQUM7QUFiVyxRQUFBLFNBQVMsYUFhcEI7QUFFSyxNQUFNLElBQUksR0FBRyxDQUFVLFlBQWUsRUFBRSxFQUFFO0lBQy9DLE1BQU0sV0FBVyxHQUFHLElBQUksdUJBQVUsRUFBSyxDQUFDO0lBRXhDLFdBQVcsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7SUFFL0IsT0FBTyxXQUFXLENBQUM7QUFDckIsQ0FBQyxDQUFDO0FBTlcsUUFBQSxJQUFJLFFBTWY7QUFFSyxNQUFNLFVBQVUsR0FBRyxDQUN4QixFQUE2QyxFQUNiLEVBQUU7SUFDbEMsSUFBSSxXQUFXLEdBQW1DLElBQUksQ0FBQztJQUV2RCxJQUFJLENBQUMsRUFBRSxFQUFFO1FBQ1AsT0FBTyxJQUFJLENBQUM7S0FDYjtJQUVELE1BQU0sWUFBWSxHQUFHLElBQUEsWUFBSyxFQUFDLENBQUMsUUFBYSxFQUFFLEVBQUU7UUFDM0MsSUFBSSxXQUFXLEVBQUU7WUFDZixXQUFXLENBQUMsSUFBSSxDQUNkLEVBQUUsQ0FBQztnQkFDRCxLQUFLLEVBQUUsR0FBRyxFQUFFLENBQUMsWUFBWSxDQUFDLFFBQVEsQ0FBQztnQkFDbkMsTUFBTSxFQUFOLGdCQUFNO2dCQUNOLE9BQU8sRUFBUCxjQUFPO2FBQ1IsQ0FBQyxDQUNILENBQUM7U0FDSDtJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsTUFBTSxPQUFPLEdBQUcsRUFBRSxDQUFDLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBRSxNQUFNLEVBQU4sZ0JBQU0sRUFBRSxPQUFPLEVBQVAsY0FBTyxFQUFFLENBQUMsQ0FBQztJQUU3RCxXQUFXLEdBQUcsSUFBQSxZQUFJLEVBQUMsT0FBTyxDQUFDLENBQUM7SUFFNUIsT0FBTyxXQUFXLENBQUM7QUFDckIsQ0FBQyxDQUFDO0FBMUJXLFFBQUEsVUFBVSxjQTBCckIifQ==